import Vue from 'vue'
import App from './App.vue'
import router from './router';
import './registerServiceWorker';
import store from './store';
import vuetify from './plugins/vuetify';
import VeeValidate from 'vee-validate';
import './lodash';

Vue.config.productionTip = false

if (localStorage.getItem('CHATBOT_USER')) {
  const parsedSession = JSON.parse(localStorage.getItem('CHATBOT_USER'));
  store.dispatch('createSession', parsedSession);
}
Vue.use(VeeValidate);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
